import { render } from "./getChangeReqs.vue?vue&type=template&id=0e785e18&scoped=true"
import script from "./getChangeReqs.vue?vue&type=script&lang=js"
export * from "./getChangeReqs.vue?vue&type=script&lang=js"

import "./getChangeReqs.vue?vue&type=style&index=0&id=0e785e18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e785e18"]])

export default __exports__